module.exports = __webpack_public_path__ + "static/ray-8df19ff90856cf2b6f0cce2b0e30c56a.jpg";